module.exports = __webpack_public_path__ + "static/media/nonord-c-12.08a73514.mp3";